//--------------------------------------------------------------------
//                     How this all works
// To start we need to initSearch.  This takes a bunch of IDs to crawl
// down and builds an array of objects.
// Comment Ascii art is "ANSI Regular"
//--------------------------------------------------------------------
import { currentUserId } from '@/store/useAuth';
import { ref, computed } from '@vue/composition-api';
import Fuse from 'fuse.js';
import dayjs from 'dayjs';
import { pagesModule } from '@/store/database/pagesModule';
import { contextsModule } from '@/store/database/contextsModule';
import useContext from '@/views/Context/use/useContext';
import { state } from '@/views/Context/components/ContentSection/Outline/useOutline';
import { result } from 'lodash';
import { search } from 'core-js/fn/symbol';
document.addEventListener('keydown', selectionKeyDownHandler);
document.addEventListener('keyup', selectionKeyUpHandler);

let fuseDB;
let allRootIdsForSearch = [];
const currRootIdDetails = ref([]);
const storedSearchTerm = ref('');
const storedSearchFilters = ref({
  archivedByFilter: 'Archived by anyone',
  dateFilter: 'day',
  panelFilter: 'On any panel',
  domainFilter: []
});
const searchResults = ref([]);

// let fuzzyDB;
const showSearch = ref(false);
const showQuickSearch = ref(false);

export default function useSearch() {
  // ██ ███    ██ ██ ████████
  // ██ ████   ██ ██    ██
  // ██ ██ ██  ██ ██    ██
  // ██ ██  ██ ██ ██    ██
  // ██ ██   ████ ██    ██

  const initSearch = ({ options }) => {
    console.log('State', state);
    let searchArray = [];
    updateFilters({ domainFilter: [state.domains[0].id] });
    //storedSearchFilters.domainFilter = domainList;
    const domainsToSearch = getDomainsToSearch(domainList.value);
    console.log('heres domainsToSearch', domainsToSearch);

    domainsToSearch.forEach(domain => {
      const panelIds = getPanelIds(domain);
      const archivedNoteIds = getArchivedObjectIds(domain);
      currRootIdDetails.value = [...panelIds, ...archivedNoteIds];
      allRootIdsForSearch = [...allRootIdsForSearch, ...currRootIdDetails.value];
      console.log('allrootidsforsearch', allRootIdsForSearch);
      searchArray = [...searchArray, ...buildSearchDatabase(domain)];
    });

    // let combinedSearchArray = [...searchArray, ...buildNoteCardDB()];
    console.log('Search Database', searchArray);

    //  initiate fuse with that array
    const fuseOptions =
      options !== undefined
        ? options
        : {
            isCaseSensitive: false,
            includeScore: true,
            // shouldSort: true,
            includeMatches: true,
            findAllMatches: false,
            minMatchCharLength: 3,
            // location: 0,
            threshold: 0.15,
            // distance: 100,
            // useExtendedSearch: false,
            ignoreLocation: true,
            // ignoreFieldNorm: false,
            keys: ['title']
          };
    fuseDB = new Fuse(searchArray, fuseOptions);
    buildResultTrees();
  };

  // ███████ ███████  █████  ██████   ██████ ██   ██
  // ██      ██      ██   ██ ██   ██ ██      ██   ██
  // ███████ █████   ███████ ██████  ██      ███████
  //      ██ ██      ██   ██ ██   ██ ██      ██   ██
  // ███████ ███████ ██   ██ ██   ██  ██████ ██   ██

  const updateSearchTerm = newTerm => {
    storedSearchTerm.value = !newTerm ? '' : newTerm;
    buildResultTrees();
  };

  //------------------------------------------------------------------------------------------------
  const buildResultTrees = () => {
    if (storedSearchTerm.value.length > 2 && fuseDB != undefined) {
      // removing space at the beginning and end of search term
      const cleanedSearchPattern = cleanUpSearchPattern(storedSearchTerm.value);

      //Generate results using the Fuse object
      const fuseResults = fuseDB.search(cleanedSearchPattern).sort(function(a, b) {
        return a.score - b.score;
      });
      //convert fuse results into a flatter object with more details
      const results = fuseResults.map((result, index) => {
        const withinAweek = daysAgo(result.item.branchLastUpdated.seconds * 1000) < 7;

        const a = isPerfectResult(result.item.title, cleanedSearchPattern);
        const perfectMatchLocation = a.matchLocation;
        const perfectMatch = a.isPerfect;
        let matchIndexes;

        if (perfectMatch) {
          matchIndexes = [
            perfectMatchLocation,
            cleanedSearchPattern.length + perfectMatchLocation - 1
          ];
        } else {
          matchIndexes = findBiggestMatch(result.matches[0].indices);
        }
        return {
          ...result.item,
          index,
          matchIndexes: matchIndexes,
          score: result.score - perfectMatch * 10 - withinAweek * 1,
          children: getChildrenArray(result.item.id),
          highlightString: getHighlightedString(result.item.title, matchIndexes),
          isPerfectResult: perfectMatch
        };
      });

      let filteredResults = filterResults(results);

      let a = filteredResults.sort(function(a, b) {
        return a.score - b.score;
      });

      let resultsTree = treeifySearchResults(a);
      console.log('results tree', resultsTree);

      addAvatarsToTree(resultsTree);

      if (filteredResults.length) {
        // printTree(resultsTree, '|');
      }

      //If I want to break apart the tree into different pieces, do that here
      //maybe make a convertTreeToResults function, pass in the tree and then split
      //out results a differen tway
      searchResults.value = breakApartTreeResults(resultsTree);

      // searchResults.value = resultsTree.children;
    } else {
      searchResults.value = [];
    }
    console.log('search results', searchResults);
  };

  // const updateDomains = domainIds => {
  //   console.log('updating domains', storedSearchFilters, domainIds);
  //   storedSearchFilters.value.domainFilter = domainIds;
  //   initSearch();
  // };

  const domainList = computed(() => {
    return contextsModule.data.values().filter(c => c.version == 2);
  });

  const updateFilters = ({ archivedByFilter, dateFilter, panelFilter, domainFilter }) => {
    if (archivedByFilter) {
      storedSearchFilters.value.archivedByFilter = archivedByFilter;
    }
    if (dateFilter) {
      storedSearchFilters.value.dateFilter = dateFilter;
    }
    if (panelFilter) {
      storedSearchFilters.value.panelFilter = panelFilter;
    }
    if (domainFilter) {
      storedSearchFilters.value.domainFilter = domainFilter;
      if (!domainFilter) {
        console.log('No domains selected');
      }
    }
    console.log('updating filters!', storedSearchFilters.value);

    buildResultTrees();
  };

  return {
    dayjs,
    showQuickSearch,
    searchResults,
    initSearch,
    showSearch,
    toggleShowSearch,
    toggleShowQuickSearch,
    updateSearchTerm,
    updateFilters,
    storedSearchTerm,
    domainList,
    buildResultTrees
  };
}

// ███    ███  █████  ██   ██ ███████     ██████  ██████
// ████  ████ ██   ██ ██  ██  ██          ██   ██ ██   ██
// ██ ████ ██ ███████ █████   █████       ██   ██ ██████
// ██  ██  ██ ██   ██ ██  ██  ██          ██   ██ ██   ██
// ██      ██ ██   ██ ██   ██ ███████     ██████  ██████

// Go through each rootId and add each to the database
function buildSearchDatabase(domain) {
  console.log('here are the root ids', currRootIdDetails.value);
  let noteCardDb = [];
  let currentDb;

  currRootIdDetails.value.forEach((rootIdDetail, index) => {
    currentDb = buildSearchDbFromId(rootIdDetail, [], [], false, index, domain);
    if (currentDb) {
      noteCardDb = [...noteCardDb, ...currentDb.searchArray];
    }
  });
  return noteCardDb;
}

//How this works: The search database is an array of all the text fields that we want to search
//each array item has the text, breadcrumbs, branchLastUpdated, etc.  We go recursively go down the tree
//adding each node to the search database.
function buildSearchDbFromId(
  rootIdDetail,
  crumbs = [],
  searchArray,
  _isInANoteCard,
  currIdIndex,
  domain
) {
  // -------(1) get the root page-------
  let rootPage;
  let alreadyAdded = false;

  // check for errors in finding root page and return if there's a problem
  try {
    rootPage = pagesModule.doc(rootIdDetail.pageId).data;
  } catch (e) {
    console.log('Cant find root page', rootIdDetail.pageId, e);
    return;
  }
  if (!rootPage) return;

  //check to see the current page is in the archive
  const isInANoteCard = _isInANoteCard || rootPage.noteCard;

  // -------(2) get the page title and when the branch was last updated-------
  let rootTitle = rootPage.title.replace(/(<([^>]+)>)/gi, ''); // This strips the HTML tags
  rootTitle = rootTitle.replace(/(\r\n|\n|\r)/gm, '');
  let branchLastUpdated = rootPage.updated_at ? rootPage.updated_at : rootPage.createdOn;
  let currentChildLastUpdated;

  // ------- (3) build an array of all the children pages so we can recurse down those -------
  let childrenPageArr = Object.values(rootPage.pageNotes).filter(
    n => n !== undefined && !n.toDelete && n.id && n.type == 'card' && n.pageId
  );

  // // ------- (3A) filter out any ids that are duplicates
  const context = contextsModule.doc(domain.id).data;

  // get onUserPanel for the current rootPage
  let onUserPanels = rootPage.onUserPanels;

  //if onUserPanel is defined and > 0, the page is in multiple locations and we need to filter some of them
  //the way we do that is by setting a flag 'alreadyAdded' to be true if the notePage has been added
  //then later we check alreadyAdded before adding it to the db
  if (typeof onUserPanels !== 'undefined' && onUserPanels.length > 0) {
    alreadyAdded = false;

    onUserPanels.forEach(userId => {
      const pageId = context.userPanels[userId]; //this gets the pageId associated with that user
      const indexLocation = currRootIdDetails.value.findIndex(element => {
        return element.pageId == pageId;
      }); //this finds the location of that pageId in the master list of rootIDs to search
      if (indexLocation < currIdIndex) {
        alreadyAdded = true;
        // console.log('already in the database:', rootPage);
      }
    });
  } else {
    onUserPanels = [currentUserId.value];
  }

  //-------- (3B) Add a list of users to those cards that are on multiple panels/archive
  // onUserPanels is a list of user ids, I need to go look at the Context and find the root note pages associated with each panel
  // Check here context.userPanels for the list of key/value pairs.  Do contex.userpanel[userID] --> that returns the page ID
  //go through the userIds in "onUserPanels"
  if (onUserPanels.length == 0) {
    console.log('found it', rootPage);
  }

  let locations = getLocations(onUserPanels);

  //------- (4) if there are any children recurse down those-------
  if (!alreadyAdded) {
    if (childrenPageArr.length) {
      //for each child, recurse and build an array out of it
      //it'll all be empty arrays until we find the right page ID
      childrenPageArr.forEach(child => {
        const currChildId = child.pageId;
        if (!currChildId) {
          return;
        }
        let currentDB = buildSearchDbFromId(
          { pageId: currChildId, type: rootIdDetail.rootType },
          [
            ...crumbs,
            {
              id: rootIdDetail.pageId,
              title: rootTitle,
              type: Number(rootPage.type)
            }
          ],
          searchArray,
          isInANoteCard,
          currIdIndex,
          domain
        );

        if (!currentDB) return;
        currentChildLastUpdated = currentDB.branchLastUpdated;
        branchLastUpdated =
          currentChildLastUpdated.seconds > branchLastUpdated.seconds
            ? currentChildLastUpdated
            : branchLastUpdated;
      });
    }
    searchArray.push({
      id: rootIdDetail.pageId,
      title: rootTitle,
      archived: rootPage.toDelete,
      type: Number(rootPage.type),
      dateCreated: rootPage.createdOn,
      breadcrumbs: crumbs,
      isInANoteCard: isInANoteCard,
      lastUpdated: rootPage.updated_at,
      branchLastUpdated: branchLastUpdated,
      locations: locations
    });
  }
  return { branchLastUpdated, searchArray };
}

const getDomainsToSearch = domainList => {
  let domains = [];
  const domainIdsFromFilter = storedSearchFilters.value.domainFilter;
  domainIdsFromFilter.forEach(id => {
    const domainDetail = domainList.find(element => element.id == id);
    domains.push(domainDetail);
  });
  return domains;
};

// const getDomainsToSearch = domainList => {
//   let domains = [];
//   const domainIdsFromFilter = storedSearchFilters.value.domainFilter;

//   //If no domains are active and no domains in the filter, search all domains
//   if (state.domains.length == 0 && domainIdsFromFilter.length == 0) {
//     // else, (nothign is selected), search all the domains
//     domains = domainList;
//     console.log('No Domains in filter.  No active domains.  Searching all domains', domains);
//     return domains;
//   } else if (domainIdsFromFilter.length == 0) {
//     //if there's an active Context, make that the domain and then return
//     //use state.
//     const activeContextId = state.domains[0].id;
//     domains = [domainList.find(element => element.id == activeContextId)];
//     console.log(
//       'No Domains in filter.  Using active Context as the domain',
//       domains,
//       activeContextId,
//       state
//     );
//     domainIdsFromFilter.forEach(id => {
//       const domainDetail = domainList.find(element => element.id == id);
//       domains.push(domainDetail);
//     });
//   } else {
//     domainIdsFromFilter.forEach(id => {
//       const domainDetail = domainList.find(element => element.id == id);
//       domains.push(domainDetail);
//     });
//   }
//   return domains;
// };

// There are multiple root IDs per Domain to search.  One for each user panel and one for each note in the archive
const getPanelIds = domain => {
  let userDetails = [];
  const context = contextsModule.doc(domain.id).data;

  console.log("here's the domain Id I'm using", context, domain);

  //Get the users (users is an object of userID,panelIds)and sort them so the current user is listed first
  let users = Object.entries(context.userPanels);
  users.forEach((user, index) => {
    if (user[0] == currentUserId.value) {
      users[index] = users[0];
      users[0] = user;
    }
  });
  //map the function to just be the panel IDs
  userDetails = users.map(user => {
    const userId = user[0];
    const pageId = user[1];
    console.log(userId);
    const userName = context.authors[userId].name;
    const avatarUrl = context.authors[userId].avatar;

    return {
      userId: userId,
      rootType: 'panel',
      pageId: pageId,
      userName: userName,
      avatarUrl: avatarUrl,
      domain: domain
    };
  });

  return userDetails;
};

const getArchivedObjectIds = domain => {
  let archiveCardDetails = [];

  //Get all the archived pages/bullets/notecards/whatever we're calling them
  const archivedObjects = pagesModule
    .where('noteCard', '==', true)
    .where('toDelete', '!=', true)
    .where('context', '==', domain.id)
    .data.values();

  // ALSO, where context domain ID = domain ID

  //filter out all pages that are on someone's panel (this removes duplicates)
  let filteredObjectIds = [];
  archivedObjects.forEach(object => {
    if (typeof object.onUserPanels == 'undefined' || object.onUserPanels.length == 0) {
      filteredObjectIds.push({ id: object.id, type: 'archive' });
    }
  });
  filteredObjectIds.forEach(pageId => {
    archiveCardDetails.push({ pageId: pageId.id, rootType: 'archive', domain: domain });
  });
  return archiveCardDetails;
};

// ███████ ██ ██      ████████ ███████ ██████  ███████
// ██      ██ ██         ██    ██      ██   ██ ██
// █████   ██ ██         ██    █████   ██████  ███████
// ██      ██ ██         ██    ██      ██   ██      ██
// ██      ██ ███████    ██    ███████ ██   ██ ███████

const filterResults = (results = []) => {
  let filteredResults = [];
  if (results.length > 0) {
    filteredResults = results.filter(result => {
      const passDateFilter = filterDate(result.branchLastUpdated.toDate());
      const passPanelFilter = filterPanel(result);
      const passArchiveFilter = filterArchivedBy(result);

      console.log('filter', passDateFilter, passPanelFilter, storedSearchFilters);
      if (!passDateFilter || !passPanelFilter || !passArchiveFilter) {
        return false;
      } else return true;
    });
  }
  console.log('results', results, 'Filtered results', filteredResults);
  return filteredResults;
};

const filterDate = lastUpdatedDate => {
  let daysAllowed;
  const today = dayjs();
  const lastUpdatedDayJS = dayjs(lastUpdatedDate);
  const dateFilter = storedSearchFilters.value.dateFilter;

  daysAllowed =
    dateFilter == 'Within 1 week'
      ? 7
      : dateFilter == 'Within 1 month'
      ? 31
      : dateFilter == 'Within 1 year'
      ? 365
      : Infinity;

  const withinDateRange = today.diff(lastUpdatedDayJS, 'day', true) <= daysAllowed;

  return withinDateRange;
};

const filterPanel = result => {
  let keepResult = true;
  let isOnMyPanel = true;
  const panelFilter = storedSearchFilters.value.panelFilter; //  { title: 'On any panel' }, { title: 'Only my panel' }, { title: 'Exclude panel' }
  const isInArchive = result.isInANoteCard;
  const context = contextsModule.doc(state.domains[0].id).data;
  const currentPanelId = context.userPanels[currentUserId.value];

  console.log(result);
  if (result.breadcrumbs.length > 0) {
    const firstBreadCrumbId = result.breadcrumbs[0].id;
    isOnMyPanel = firstBreadCrumbId == currentPanelId;
  }

  if (isInArchive) {
    keepResult = true;
  } else {
    if (panelFilter == 'On any panel') {
      keepResult = true;
    } else if (panelFilter == 'Only my panel') {
      keepResult = isOnMyPanel;
    } else if (panelFilter == 'Exclude panel') {
      keepResult = false;
    }
  }
  return keepResult;
};

const filterArchivedBy = result => {
  let rootId;
  let keepResult = true;
  const panelFilter = storedSearchFilters.value.archivedByFilter; //  'Archived by anyone' 'Archived by me' 'Exclude archive'
  const isInArchive = result.isInANoteCard;
  let archivedByCurrentUser;
  const currentUserId = state.domains[0].panel;

  if (isInArchive) {
    console.log('result', result);
    if (result.breadcrumbs.length == 0) {
      rootId = result.id;
    } else rootId = result.breadcrumbs[0].id;
    const currPage = pagesModule.doc(rootId).data;
    const archivedBy = currPage.createdBy;
    archivedByCurrentUser = archivedBy == currentUserId;
    console.log('current page', currPage);
  }
  if (isInArchive) {
    if (panelFilter == 'Archived by anyone') {
      keepResult = true;
    } else if (panelFilter == 'Archived by me') {
      keepResult = archivedByCurrentUser;
    } else if (panelFilter == 'Exclude archive') {
      keepResult = false;
    }
  }
  return keepResult;
};

// ████████ ██████  ███████ ███████      ██████  █████  ██████  ██████  ███████
//    ██    ██   ██ ██      ██          ██      ██   ██ ██   ██ ██   ██ ██
//    ██    ██████  █████   █████       ██      ███████ ██████  ██   ██ ███████
//    ██    ██   ██ ██      ██          ██      ██   ██ ██   ██ ██   ██      ██
//    ██    ██   ██ ███████ ███████      ██████ ██   ██ ██   ██ ██████  ███████
//------------------------------------------------------
// goes through each result and adds them to a giant tree
//------------------------------------------------------
function treeifySearchResults(results) {
  //This is the root node of the whole result tree
  let searchResultTree = {
    id: 'ROOT',
    title: 'ROOT',
    type: 11,
    order: 0,
    depth: 0,
    dateCreated: new Date(),
    branchLastUpdated: new Date(),
    results: [],
    resultsWithinBranch: [],
    children: [],
    score: Infinity
  };

  if (results.length == 0) {
    return {};
  }

  //Go through each of the results and call the recursive addCrumbToTree function on each result.  This
  // will build a big tree that holds all the results in a structure.
  results.forEach(result => {
    const resultBreadCrumb = [...result.breadcrumbs];
    //complete the breadCrumb by adding the result to it - this makes it easier to handle in a tree
    const resultCrumb = {
      id: result.id,
      title: result.title,
      type: result.type
    };
    resultBreadCrumb.push(resultCrumb);
    searchResultTree = addCrumbToTree(result, searchResultTree, resultBreadCrumb);
    // printBreadCrumb(result.breadcrumbs);
  });
  return searchResultTree;
}

function daysAgo(date) {
  let today = new Date();
  return (today - date) / (1000 * 60 * 60 * 24);
}

//
function addCrumbToTree(result, subTree, subCrumb) {
  // console.log('heres a subtree', subTree);

  //first, at the current node, whether it's the result node or not, add the result so each
  //branch knows what result is at the end of it.
  subTree.resultsWithinBranch.push(result);

  //update the date
  subTree.branchLastUpdated = dayjs(subTree.branchLastUpdated).isAfter(
    dayjs(result.branchLastUpdated)
  )
    ? result.branchLastUpdated
    : subTree.branchLastUpdated;
  subTree.score = Math.min(subTree.score, result.score);

  //if there is only 1 breadCrumb left, that means it's the result.
  if (subCrumb.length == 0) {
    subTree.results.push(result);
    subTree.score = result.score;
    return;
  }

  //get the ID to compare to the tree node.
  const crumbID = subCrumb[0].id;
  const crumbTitle = subCrumb[0].title;
  const crumbType = subCrumb[0].type;
  // console.log('SubCrumb', subCrumb[0]);

  //search for the crumbID in the children of the rootNode of the subTree
  const childIndex = subTree.children
    .map(child => {
      return child.id;
    })
    .indexOf(crumbID);

  //if the crumb was found recurse on that child with the first crumb removed
  if (childIndex >= 0) {
    const newRoot = subTree.children[childIndex];
    addCrumbToTree(result, newRoot, subCrumb.slice(1, subCrumb.length));
  } else {
    //otherwise, add a new child

    //---HERE HERE HERE---
    // forst, let's add location details if needed.
    // Condition 1: if you're one of the root nodes (depth is 1)
    // condition 2: a bullet is located in 2 locations (e.g. 2 panels or a panel and an archive)
    let locations = [];
    const currPage = pagesModule.doc(subCrumb[0].id).data;

    // console.log('heres what I got', subTree, result);
    if (subTree.depth == 0) {
      locations = [allRootIdsForSearch.find(detail => detail.pageId == subCrumb[0].id)];
    } else if (currPage.onUserPanels && currPage.onUserPanels.length > 1) {
      //add location
      locations = getLocations(currPage.onUserPanels);
    }

    const newChild = {
      id: crumbID,
      title: crumbTitle,
      type: crumbType,
      order: subTree.children.length,
      depth: subTree.depth + 1,
      dateCreated: result.dateCreated,
      branchLastUpdated: result.branchLastUpdated,
      results: [],
      resultsWithinBranch: [],
      children: [],
      score: Infinity,
      locations: locations
    };
    subTree.children.push(newChild);
    addCrumbToTree(
      result,
      subTree.children[subTree.children.length - 1],
      subCrumb.slice(1, subCrumb.length)
    );
  }
  return subTree;
}
// ███████ ██    ██ ███████ ███    ██ ████████     ██   ██  █████  ███    ██ ██████  ██      ██ ███    ██  ██████
// ██      ██    ██ ██      ████   ██    ██        ██   ██ ██   ██ ████   ██ ██   ██ ██      ██ ████   ██ ██
// █████   ██    ██ █████   ██ ██  ██    ██        ███████ ███████ ██ ██  ██ ██   ██ ██      ██ ██ ██  ██ ██   ███
// ██       ██  ██  ██      ██  ██ ██    ██        ██   ██ ██   ██ ██  ██ ██ ██   ██ ██      ██ ██  ██ ██ ██    ██
// ███████   ████   ███████ ██   ████    ██        ██   ██ ██   ██ ██   ████ ██████  ███████ ██ ██   ████  ██████

//This handles the ctrl+F stuff
function selectionKeyDownHandler(event) {
  if (event.keyCode == 70 && event.ctrlKey) {
    const input = document.getElementById('quickSearch');
    if (input != document.activeElement) {
      event.preventDefault();
    }
    input.focus();
    input.select();
  }
}
function selectionKeyUpHandler(event) {
  if (event.keyCode == 27) {
    toggleShowSearch(false);
  }
}

export const toggleShowSearch = value => {
  console.log('ShowSearch = ' + value);
  if (value !== undefined) {
    showSearch.value = value;
  } else {
    showSearch.value = !showSearch.value;
  }
  storedSearchFilters.value = {
    archivedByFilter: 'anyone',
    dateFilter: 'day',
    panelFilter: 'On any panel',
    domainFilter: []
  };
};

const toggleShowQuickSearch = value => {
  if (value !== undefined) {
    showQuickSearch.value = value;
  } else {
    showQuickSearch.value = !showQuickSearch.value;
  }
};

// ██   ██ ███████ ██      ██████  ███████ ██████  ███████
// ██   ██ ██      ██      ██   ██ ██      ██   ██ ██
// ███████ █████   ██      ██████  █████   ██████  ███████
// ██   ██ ██      ██      ██      ██      ██   ██      ██
// ██   ██ ███████ ███████ ██      ███████ ██   ██ ███████

// const filterDuplicate = (userId, onUserPanels) => {
//   let filterIt = false;
//   console.log('on user panels', onUserPanels);
// };

const breakApartTreeResults = treeResults => {
  const iconContainerTypes = [12, 5, 19, 7, 11, 8]; //for the future if we want to be smart and stuff
  const sectionType = 10;
  let splitResults = [];

  //The first children in the tree should be panels and archived cards.  Add all archived cards to the result array
  if (treeResults.children) {
    treeResults.children.forEach(topLevelItem => {
      // console.log('topLevelItem', topLevelItem);
      const itsAnoteCard = topLevelItem.resultsWithinBranch[0].isInANoteCard;

      if (itsAnoteCard) {
        topLevelItem.isTopOfCard = true;
        splitResults.push(topLevelItem);
        //the second children (once the archived cards are removed) will be top level panel items
      } else if (topLevelItem.children) {
        topLevelItem.children.forEach(panelRoot => {
          console.log('panelRoot', panelRoot);
          panelRoot.locations = topLevelItem.locations;
          panelRoot.isTopOfCard = true;
          splitResults.push(panelRoot);
        });
      }
    });
  }
  // const isSection = panelRoot.type == sectionType;
  // const isContainer = iconContainerTypes.includes(panelRoot.Type);
  // if(isSection || isContainer) {
  //   splitResults.push(panelItem)
  // }
  return splitResults;
};

const getLocations = userIds => {
  if (userIds.length == 0) {
    console.log('getting locations', userIds, currRootIdDetails.value);
  }
  let locations = [];
  userIds.forEach(userId => {
    currRootIdDetails.value.forEach(detail => {
      if (detail.userId == userId) {
        locations.push(detail);
      }
    });
  });
  if (typeof locations[0] == 'undefined') {
    console.log('LOCATION UNDEFINED:', userIds, currRootIdDetails.value);
  }
  return locations;
};
//adds user/panel avatars to the tree
const addAvatarsToTree = resultTree => {};

//returns an array of children pageIDs
const getChildrenArray = rootID => {
  let rootPage = pagesModule.doc(rootID).data; //gets the root page
  let childrenArray = [];
  Object.values(rootPage.pageNotes).forEach(n => {
    if (n !== undefined && !n.toDelete && n.id && n.type == 'card' && n.pageId) {
      const childPage = pagesModule.doc(n.pageId).data;
      if (childPage == undefined) {
        return;
      }
      childrenArray.push({
        id: n.pageId,
        title: childPage.title.replace(/(<([^>]+)>)/gi, ''),
        type: childPage.type,
        order: n.order
      });
    }
  });

  childrenArray.sort((a, b) => (a.order > b.order ? 1 : -1));

  return childrenArray;
};

function isPerfectResult(title, searchTerm) {
  let firstIndexIsAtBeginning, lastIndexIsAtEnd;
  let hasSpaceOrPunctuationBefore = false;
  let hasSpaceOrPunctuationAfter = false;

  function isCharacterALetter(char) {
    return char.toLowerCase() != char.toUpperCase();
  }
  //get the first match in the string
  let matchLocation = title.toLowerCase().search(searchTerm.toLowerCase());

  //if no match found, exit function
  if (matchLocation == -1) {
    return { isPerfect: false, matchLocation: -1 };
  }

  //otherwise, check to make sure it is a perfect match
  firstIndexIsAtBeginning = matchLocation == 0;
  lastIndexIsAtEnd = searchTerm.length + matchLocation == title.length;
  if (!firstIndexIsAtBeginning) {
    hasSpaceOrPunctuationBefore = !isCharacterALetter(title[matchLocation - 1]);
  }
  if (!lastIndexIsAtEnd) {
    hasSpaceOrPunctuationAfter = !isCharacterALetter(title[searchTerm.length + matchLocation]);
  }

  let isPerfect =
    (firstIndexIsAtBeginning || hasSpaceOrPunctuationBefore) &&
    (lastIndexIsAtEnd || hasSpaceOrPunctuationAfter);

  //if it's not a perfect match, then, if there's any more string left, go
  // search again in the next part of the string
  if (!isPerfect && title.length >= matchLocation + searchTerm.length) {
    let a = isPerfectResult(title.substring(matchLocation + searchTerm.length), searchTerm);
    isPerfect = a.isPerfect;
    matchLocation = a.matchLocation + matchLocation + searchTerm.length;
  }
  return {
    isPerfect,
    matchLocation
  };
}

//The Fuse search results give a good match, then a whole bunch of garbage.  This gets the largest match which is usually the best
function findBiggestMatch(matchIndexArray) {
  const biggestMatch = matchIndexArray.reduce(
    (prev, current) => {
      if (current[1] - current[0] > prev[1] - prev[0]) {
        return current;
      } else {
        return prev;
      }
    },
    [0, 0]
  );
  return biggestMatch;
}

//matchIndexArray is of the form [[0,3], [12,15]...]
//this function should return an array of the form [{text: "foo", highlight: false}, {text: "bar", highlight:true}]
function getHighlightedString(originalString, matchIndexArray, maxStringLength) {
  const resultArray = [];
  if (matchIndexArray[0] !== 0) {
    const pretext = originalString.slice(0, matchIndexArray[0]);
    resultArray.push({ text: pretext, highlight: false });
  }
  // const end = originalString.length - 1 == match[1] ? match[1] + 1 : match[1];
  const text = originalString.slice(matchIndexArray[0], matchIndexArray[1] + 1);
  resultArray.push({ text, highlight: true });

  if (matchIndexArray[1] < originalString.length) {
    //  add the non highlighted space after
    const text = originalString.slice(matchIndexArray[1] + 1);
    resultArray.push({ text, highlight: false });
  }
  return resultArray;
}

//This removes the spaces before and after the search pattern if they exist
function cleanUpSearchPattern(searchPattern) {
  // removing space at the beginning and end of search term
  let cleanedSearchPattern = searchPattern;
  if (searchPattern[0] == ' ') {
    cleanedSearchPattern = searchPattern.substring(1);
  }
  if (cleanedSearchPattern[cleanedSearchPattern.length - 1] == ' ') {
    cleanedSearchPattern = cleanedSearchPattern.substring(0, cleanedSearchPattern.length - 1);
  }
  return cleanedSearchPattern;
}

//unused
function stripHTML(textToStrip) {
  var div = document.createElement('div');
  div.innerHTML = textToStrip;
  return div.textContent || div.innerText || '';
}

// prints a tree in the console
function printTree(resultTree, spaces) {
  let postString = '';
  if (resultTree.results.length) {
    postString = ' *';
  }

  console.log(spaces + resultTree.title.slice(0, 10) + postString);
  const newSpaces = spaces + '--';
  resultTree.children.forEach(child => {
    printTree(child, newSpaces);
  });
}

const trimStringLeft = (initialString, length) => {
  let shortenedString;
  if (initialString.length > length) {
    shortenedString = '...' + initialString.substring(initialString.length - length);
  }
  return shortenedString;
};
